import { Typography, DialogProps, Button as MuiButton } from "@mui/material";
import { Dialog, DialogActions, DialogContent } from "components";
import { Theme } from "@mui/material/styles";
import withStyles from '@mui/styles/withStyles';
import { useTranslation } from "react-i18next";
import { useStyles } from "./confirmation-popup.style";
import _ from "lodash";

const Button = withStyles((theme: Theme) => ({
  root: {
    flex: 1,
    borderRadius: "100px",
    "&.Mui-focusVisible": {
      outline: "2px solid #000000",
    },
    textTransform: "none",
    whiteSpace: "nowrap",
  },
  label: {
    fontSize: 12,
    fontWeight: 700,
  },
  disabled: {
    color: theme.palette.grey["500"],
  },
}))(MuiButton);
type ConfirmationPopupProps = DialogProps & {
  open: boolean;
  title: string;
  handleConfirmed: () => void;
  handleClose: (val: false) => void;
  message: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
};
export const ConfirmationPopup = ({
  open,
  title,
  handleConfirmed,
  handleClose,
  message,
  confirmLabel,
  cancelLabel,
  ...props
}: ConfirmationPopupProps): React.ReactElement => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog
      id="confirmdialog"
      onClose={(() => handleClose(false)) as any}
      aria-labelledby="confirm_dialog"
      classes={{ paper: classes.dialog }}
      open={open}
      {...{
        disableEscapeKeyDown: true,
        ...props,
      }}
    >
      <DialogContent>
        <Typography component={"h2"} id="confirm_dialog" className={classes.dialogHeader}>
          {title}
        </Typography>
        <Typography className={classes.dialogMessage}>
          <span aria-hidden="true">{message}</span>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          id="confirm_button"
          onClick={() => {
            handleClose(false);
            handleConfirmed();
          }}
          variant="outlined"
          className={`${classes.confirmButton}`}
          aria-label={confirmLabel ?? t("confirm")}
        >
          {confirmLabel ?? _.capitalize(t("confirm"))}
        </Button>
        <Button
          id="cancel_button"
          onClick={() => handleClose(false)}
          className={classes.cancelButton}
          aria-label={cancelLabel ?? t("cancel")}
        >
          {cancelLabel ?? _.capitalize(t("cancel"))}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
